import AuthPage from "./components/AuthPage";
export default AuthPage;
